import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import history from "web/script/utils/history";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./product-gallery-modal.css";

//  A different component is used for browser windows bigger then 576
const thisGalleryHiddenBreakpoint = 576;

function ProductGalleryModal({ children, onClose, onOpen, isOpen }) {
    const appElement = useRef(null);

    useEffect(() => {
        Modal.setAppElement(appElement.current);

        window.addEventListener("popstate", onBack);
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("popstate", onBack);
            window.removeEventListener("resize", onResize);
        };
    });

    function handleClose() {
        onClose();
        clearAllBodyScrollLocks();
        // since we are pushing a state onOpen we need to force
        // history back if the user don't click the back button
        history.back();
    }

    function onResize() {
        if (window.innerWidth >= thisGalleryHiddenBreakpoint && isOpen) {
            handleClose();
        }
    }

    function onBack() {
        onClose();
        clearAllBodyScrollLocks();
    }

    function handleOpen() {
        if (onOpen) {
            onOpen();
        }
        history.pushState(document.URL, { open: 1 });
        disableBodyScroll(appElement.current);
    }

    return (
        <div ref={appElement}>
            <Modal
                overlayClassName={styles.overlay}
                className={styles.modal}
                appElement={document.body}
                onAfterOpen={handleOpen}
                onRequestClose={handleClose}
                isOpen={isOpen}
            >
                <div className={styles.close}>
                    <CloseButton onClick={handleClose} />
                </div>
                {children}
            </Modal>
        </div>
    );
}

export default ProductGalleryModal;

ProductGalleryModal.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func,
    isOpen: PropTypes.bool,
};

ProductGalleryModal.defaultProps = {
    isOpen: false,
    currentSlide: 0,
};
